// @ts-nocheck
import MarkerClusterer from '@google/markerclusterer'
import {
  ContentType1,
  CreatePolygonType,
  SetClustererType,
  AnyUseRef,
  MapApiPropsType,
  CountTextType,
  OutageAreasType,
  RemoveMarkersType,
  AddMarkerType,
  PlaceChangedType,
  FeatureType
} from '../interfaces/index'

import greenMarker from '../icons/greenMarker.svg'
import orangeMarker from '../icons/orangeMarker.svg'
import redMarker from '../icons/redMarker.svg'
import majorWorksMarker from '../icons/majorWorks.svg'

export const updateGTM = (category: string, action: string, label?: string) => {
  if ((global as any).digitalData) {
    ; (global as any).digitalData.tool = {
      name: 'outages map',
      category,
      action,
      label
    }
      ; (global as any).dataLayer.push({ event: 'outageMapSearch' })
  }
}

export function getTitle(status: string): string {
  switch (status) {
    case 'Completed':
    case 'Closed':
      return 'Recently Completed Works'
    case 'Active':
      return 'Current Water Outage'
    case 'Registered':
      return 'Upcoming Water Outage'
    default:
      return ''
  }
}

export function getMessage(planned: boolen) {
  return planned ? 'Planned water on: ' : 'Estimated water on: '
}

export function getDetails(content: ContentType1): string | null {
  switch (content.status) {
    case 'Completed':
    case 'Closed':
      return getLocalDateTimeString(parseDateTime(content.actual_on))
    case 'Major':
    case 'Active':
      return getLocalDateTimeString(parseDateTime(content.estimated_on))
    case 'Registered':
      if (content.extension === 'True' && content.estimated_on) {
        return getLocalDateTimeString(parseDateTime(content.estimated_on))
      }
      if (content.planned_on) {
        return getLocalDateTimeString(parseDateTime(content.planned_on))
      } else if (content.estimated_on) {
        return getLocalDateTimeString(parseDateTime(content.estimated_on))
      }
      return ''
    default:
      return ''
  }
}

export const createPolygons = ({
  features,
  polygons,
  markers,
  markerEvents,
  infoWindow,
  map,
  state
}: CreatePolygonType) => {
  if (features && google.maps) {
    features.forEach((d) => {
      // Calculate outage type
      const type = getOutageType(d?.properties?.status)
      if (type && Array.isArray(d?.geometry?.coordinates)) {
        // Create polygons for outages and add to map
        const coordinates = d.geometry.coordinates
        for (let i = 0; i < coordinates.length; i++) {
          if (Array.isArray(coordinates[0])) {
            const paths = coordinates[i].reduce(
              (arr: Array<any>, tuple: Array<number>) => {
                const latLng = new google.maps.LatLng(tuple[1], tuple[0])
                return arr.concat(latLng)
              },
              []
            )

            const polygon = new google.maps.Polygon({
              status: d.properties.status,
              paths: paths,
              strokeColor: type && type.color ? type.color : '#FF0000',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: type && type.color ? type.color : '#FF0000',
              fillOpacity: 0.35
            })
            polygons?.current.push(polygon)

            // Create feature and add as a marker
            const feature = {
              position: polygon.getApproximateCenter(),
              status: d.properties.status,
              region: d.properties.region,
              end_date: d.properties.end_date,
              town: d.properties.town,
              start_date: d.properties.start_date,
              extension_status: d.properties.extension_status,
              estimated_off: d.properties.estimated_off,
              start_date_interruption: d.properties.start_date_interruption,
              end_date_interruption: d.properties.end_date_interruption,
              estimated_on: d.properties.estimated_on,
              planned_off: d.properties.planned_off,
              planned_on: d.properties.planned_on,
              actual_off: d.properties.actual_off,
              actual_on: d.properties.actual_on,
              extension: d.properties.extension,
              affected_suburbs: d.properties.affected_suburbs,
              affected_customers_outage: d.properties.affected_customers_outage,
              name: d?.properties.name,
              notes: d?.properties.notes,
              url: d?.properties.url,
              outagesFormUrl: state?.outagesFormUrl
            }
            addMarker({
              feature,
              markers,
              markerEvents,
              infoWindow,

              map
            })

            // Add polygon to map
            polygon.setMap(map)
          } else {
            const myLatlng = new google.maps.LatLng(
              coordinates[0],
              coordinates[1]
            )
            // Create feature and add as a marker
            const feature = {
              position: myLatlng,
              status: d.properties.status,
              region: d.properties.region,
              end_date: d.properties.end_date,
              town: d.properties.town,
              start_date: d.properties.start_date,
              extension_status: d.properties.extension_status,
              estimated_off: d.properties.estimated_off,
              start_date_interruption: d.properties.start_date_interruption,
              end_date_interruption: d.properties.end_date_interruption,
              estimated_on: d.properties.estimated_on,
              planned_off: d.properties.planned_off,
              planned_on: d.properties.planned_on,
              actual_off: d.properties.actual_off,
              actual_on: d.properties.actual_on,
              extension: d.properties.extension,
              affected_suburbs: d.properties.affected_suburbs,
              affected_customers_outage: d.properties.affected_customers_outage,
              name: d?.properties.name,
              notes: d?.properties.notes,
              url: d?.properties.url,
              outagesFormUrl: state?.outagesFormUrl
            }
            addMarker({
              feature,
              markers,
              markerEvents,
              infoWindow,

              map
            })
          }
        }
      }
    })
  }
}

export const setClusterer = ({ markers, clusterer, map }: SetClustererType) => {
  // Add a marker clusterer to manage the markers
  clusterer.current = new MarkerClusterer(map, markers?.current, {
    zoom: map.getZoom() ?? 15,
    imagePath:
      'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
  })
}

export const setMap =
  (markers: AnyUseRef, map: google.maps.Map) => (position: any) => {
    map.setZoom(15)
    map.setCenter(position)
    for (let i = 0; i < markers?.current.length; i++) {
      const marker = markers?.current[i]
      if (
        position.lat() === marker.position.lat() &&
        position.lng() === marker.position.lng()
      ) {
        new google.maps.event.trigger(marker, 'click', { skipGtm: true })
      }
    }
  }

export const createCountText = ({
  completedCount,
  upcomingCount,
  outageCount,
  majorCount
}: CountTextType) => {
  let text = ''
  if (majorCount) {
    text = text + `${majorCount} major work${majorCount > 1 ? 's' : ''}, `
  }
  if (outageCount) {
    text = text + `${outageCount} outage${outageCount > 1 ? 's' : ''}, `
  }
  if (completedCount) {
    text =
      text +
      `${completedCount} recently completed work${completedCount > 1 ? 's' : ''
      }, `
  }
  if (upcomingCount) {
    text =
      text +
      `${upcomingCount} upcoming water outage${upcomingCount > 1 ? 's' : ''}, `
  }
  return text.substring(0, text.length - 2)
}

export const createGuid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  )
}

export const getPin = (status: string) => {
  switch (status) {
    case 'Active':
      return redMarker
    case 'Registered':
      return orangeMarker
    case 'Major':
      return majorWorksMarker
    default:
      return greenMarker
  }
}

export const removeMarkers = ({
  polygons,
  markers,
  markerEvents,
  clusterer,
  status
}: RemoveMarkersType) => {
  // Iterate between each polygon and clear map that are removed
  const newPolygons = polygons?.current.reduce((array: Array<any>, curr: any) => {
    if (curr.status === status || status === 'all' || curr.type === status) {
      curr.setMap(null)
    } else {
      array.push(curr)
    }
    return array
  }, [])

  // Iterate between each marker and clear marker that are removed
  const newMarkers = markers?.current.reduce((array: Array<any>, curr: any) => {
    if (curr.markerData.status === status || status === 'all') {
      curr.setMap(null)
      clusterer?.current.removeMarker(curr)
      const position = curr.position.lat() + '-' + curr.position.lng()
      const eventListener = markerEvents?.current[position]
      google.maps && new google.maps.event.removeListener(eventListener)
      markerEvents.current[position] = null
    } else {
      array.push(curr)
    }
    return array
  }, [])

  markers.current = newMarkers
  polygons.current = newPolygons
}

// here

export const createOutageAreas = ({ markers, state }: OutageAreasType) => {
  // Create list of outages
  const tempOutages = markers?.current.reduce((array: Array<any>, curr: any) => {
    if (
      (curr.markerData.status === 'Active' && state?.active) ||
      (curr.markerData.status === 'Completed' && state?.completed) ||
      (curr.markerData.status === 'Closed' && state?.completed) ||
      (curr.markerData.status === 'Major' && state?.major) ||
      (curr.markerData.status === 'Registered' && state?.registered)
    ) {
      // Iterate between all affected suburbs and add to result
      if (
        curr.markerData.affected_suburbs &&
        curr.markerData.affected_suburbs.length > 0
      ) {
        curr.markerData.affected_suburbs.forEach((s: string) => {
          array.push({
            content: curr.markerData,
            label: s
          })
        })
      }
    }
    return array
  }, [])

  // Create list of outage areas
  const tempOutageAreas = tempOutages.reduce((array: Array<any>, curr: any) => {
    const suburb = curr.label
    const { status } = curr.content
    const index = array.map((x) => x.suburb).indexOf(suburb)
    if (index >= 0) {
      // Increment the counts and add to outages list
      if (status === 'Completed' || status === 'Closed') {
        array[index].completedCount++
      }
      if (status === 'Registered') {
        array[index].upcomingCount++
      }
      if (status === 'Active') {
        array[index].outageCount++
      }
      if (status === 'Major') {
        array[index].majorCount++
      }
      array[index].outages.push(curr)
    } else {
      // Add new suburb and sort
      array.push({
        suburb,
        isOpen: false,
        completedCount: status === 'Completed' || status === 'Closed' ? 1 : 0,
        upcomingCount: status === 'Registered' ? 1 : 0,
        outageCount: status === 'Active' ? 1 : 0,
        majorCount: status === 'Major' ? 1 : 0,
        outages: [curr]
      })
      array.sort((x, y) => {
        const xSuburb = x.suburb
        const ySuburb = y.suburb
        if (xSuburb < ySuburb) {
          return -1
        }
        if (xSuburb > ySuburb) {
          return 1
        }
        return 0
      })
    }
    return array
  }, [])
  return tempOutageAreas
}

export const resetMap = (map: google.maps.Map, ref: AnyUseRef) => {
  if (ref?.current) {
    ref?.current?.close()
  }
  map.setCenter({ lat: -27.2008942, lng: 122.0053344 })
  map.setZoom(4)
}

export const getOutageType = (
  status: string
): { type: string; color: string } | undefined => {
  if (status === 'Completed' || status === 'Closed') {
    return { type: 'complete', color: getColor.complete }
  }
  if (status === 'Active') {
    return { type: 'outage', color: getColor.outage }
  }
  if (status === 'Registered') {
    return { type: 'planned', color: getColor.planned }
  }
  if (status === 'Major') {
    return { type: 'major', color: getColor.major }
  }
}

export const getColor: { [index: string]: string } = {
  outage: '#dd1e35',
  complete: '#6fbf4a',
  planned: '#fcb526',
  major: '#f57e3a'
}

// Add new methods to the Polygon object
export const addPolygonFeature = () => {
  // Calculate the bounding box of the polygon
  google.maps.Polygon.prototype.getBoundingBox = function () {
    const bounds = new google.maps.LatLngBounds()
    this.getPath().forEach(function (element: any) {
      bounds.extend(element)
    })
    return bounds
  }

  // Calculate the approximate centre of the polygon

  google.maps.Polygon.prototype.getApproximateCenter = function () {
    let boundsHeight = 0,
      boundsWidth = 0,
      centrePoint,
      heightIncr = 0,
      maxSearchSteps = 10,
      n = 1,
      northWest,
      polygonBounds = this.getBoundingBox(),
      testPos,
      widthIncr = 0

    // Get polygon centre point
    centrePoint = polygonBounds.getCenter()
    if (new google.maps.geometry.poly.containsLocation(centrePoint, this)) {
      // Nothing to do centre point is in polygon use it as is
      return centrePoint
    } else {
      // Calculate NorthWest point so we can work out height of polygon NW->SE

      northWest = new google.maps.LatLng(
        polygonBounds.getNorthEast().lat(),
        polygonBounds.getSouthWest().lng()
      )

      // Work out how tall and wide the bounds are and what our search
      // increment will be
      boundsHeight = new google.maps.geometry.spherical.computeDistanceBetween(
        northWest,
        polygonBounds.getSouthWest()
      )
      heightIncr = boundsHeight / maxSearchSteps
      boundsWidth = new google.maps.geometry.spherical.computeDistanceBetween(
        northWest,
        polygonBounds.getNorthEast()
      )
      widthIncr = boundsWidth / maxSearchSteps

      // Expand out from centre point and find a point within polygon at 0, 90,
      // 180, 270 degrees
      for (; n <= maxSearchSteps; n++) {
        // Test point North of centre point
        testPos = new google.maps.geometry.spherical.computeOffset(
          centrePoint,
          heightIncr * n,
          0
        )
        if (new google.maps.geometry.poly.containsLocation(testPos, this)) {
          break
        }

        // Test point East of centre point
        testPos = new google.maps.geometry.spherical.computeOffset(
          centrePoint,
          widthIncr * n,
          90
        )
        if (new google.maps.geometry.poly.containsLocation(testPos, this)) {
          break
        }

        // Test point South of centre point
        testPos = new google.maps.geometry.spherical.computeOffset(
          centrePoint,
          heightIncr * n,
          180
        )
        if (new google.maps.geometry.poly.containsLocation(testPos, this)) {
          break
        }

        // Test point West of centre point
        testPos = new google.maps.geometry.spherical.computeOffset(
          centrePoint,
          widthIncr * n,
          270
        )
        if (new google.maps.geometry.poly.containsLocation(testPos, this)) {
          break
        }
      }
      return testPos
    }
  }
}

export const addMarker = ({
  feature,
  markers,
  markerEvents,
  infoWindow,
  map
}: AddMarkerType) => {
  // Create marker and add to markers

  const marker = new google.maps.Marker({
    markerData: feature,
    position: feature.position,
    optimized: false,
    icon: getIcon(feature.status, google.maps),

    animation: google.maps.Animation.DROP,
    map: map
  })
  markers?.current.push(marker)

  // Create info window

  const info = new google.maps.InfoWindow({
    content: createTemplate(feature)
  })

  // Add event listener to the marker to display info window when clicked
  const eventListener = new google.maps.event.addListener(
    marker,
    'click',
    ({ skipGtm }: { skipGtm: boolean }) => {
      if (!skipGtm) {
        updateGTM(
          'marker click',
          joinList(feature.affected_suburbs),
          feature.status
        )
      }

      if (infoWindow?.current) {
        infoWindow?.current.close()
      }

      infoWindow.current = info
      map.setCenter(marker.getPosition())
      map.setZoom(15)
      infoWindow?.current.open(map, marker)
    }
  )

  // Add event listener to the marker events
  const position = feature.position.lat() + '-' + feature.position.lng()
  markerEvents.current[position] = eventListener
}

// When the user selects a city, get the place details for the city and
// zoom the map in on the city.
export const onPlaceChanged = ({ autocomplete, map }: PlaceChangedType) => {
  const place = autocomplete.getPlace()
  if (place && place.geometry) {
    map.panTo(place.geometry.location)
    map.setZoom(13)
  }
}

export const getIcon = (status: string, google: MapApiPropsType) => {
  if (status === 'Completed' || status == 'Closed') {
    return {
      url: greenMarker,

      scaledSize: new google.Size(50, 50)
    }
  }
  if (status === 'Active') {
    return {
      url: redMarker,

      scaledSize: new google.Size(50, 50)
    }
  }
  if (status === 'Registered') {
    return {
      url: orangeMarker,

      scaledSize: new google.Size(50, 50)
    }
  }
  if (status === 'Major') {
    return {
      url: majorWorksMarker,

      scaledSize: new google.Size(50, 50)
    }
  }
}

export const parseDateTime = (dateString: string) => {
  const components = dateString.split(' ')
  if (components.length !== 2) return null
  const dateComponents = components[0].split('/')
  if (dateComponents.length !== 3) return null
  const timeComponents = components[1].split(':')
  if (timeComponents.length !== 3) return null
  return new Date(
    parseInt(dateComponents[2]),
    parseInt(dateComponents[1]) - 1,
    parseInt(dateComponents[0]),
    parseInt(timeComponents[0]),
    parseInt(timeComponents[1]),
    parseInt(timeComponents[0])
  )
}

export const getLocalDateTimeString = (dateValue: Date | null) => {
  if (!dateValue) return null
  const date = dateValue.getDate()
  const months = dateValue.getMonth() + 1
  const years = dateValue.getFullYear()
  let hours = dateValue.getHours()
  let minutes: number | string = dateValue.getMinutes()
  const ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + String(minutes) : String(minutes)
  return (
    (date < 10 ? '0' + date : date) +
    '/' +
    (months < 10 ? '0' + months : months) +
    '/' +
    years +
    ' ' +
    hours +
    ':' +
    minutes +
    ' ' +
    ampm
  )
}

function joinList(listArray: Array<string>) {
  if (!listArray || listArray.length === 0) return ''
  if (listArray.length === 1) return listArray[0]
  if (listArray.length === 2) return listArray[0] + ' and ' + listArray[1]

  const lastItem = listArray.slice(listArray.length - 1)
  const otherItems = listArray.slice(0, listArray.length - 1)
  return otherItems.join(', ') + ' and ' + lastItem
}

export const createTemplate = (details: FeatureType) => {
  const lastUpdated = getLocalDateTimeString(new Date())
  const affectedSuburbs = joinList(details.affected_suburbs)
  const outagesFormUrl = details.outagesFormUrl
  if (details.status === 'Completed' || details.status === 'Closed') {
    let actualOn = ''
    if (details.actual_on) {
      actualOn = getLocalDateTimeString(
        parseDateTime(details.actual_on)
      ) as string
    }
    return `<div class="wc-outages__message">
        <h5>Recently completed works</h5>
        <h6>Work has recently been completed at ${affectedSuburbs}</h6>
        <p>
          Maintenance was recently carried out at ${affectedSuburbs}, service has
          been restored and water was turned back on at ${actualOn}.
        </p>
        <p>
          As a result of the maintenance, you may notice discoloured water.
          Running a tap for approximately 2 minutes should return water to
          normal. If water does not return to normal, please contact us at 13 13
          75.
        </p>
      </div>`
  }
  if (details.status === 'Active') {
    let outageStart = ''
    if (details.actual_off) {
      outageStart = getLocalDateTimeString(
        parseDateTime(details.actual_off)
      ) as string
    } else if (details.estimated_off) {
      outageStart = getLocalDateTimeString(
        parseDateTime(details.estimated_off)
      ) as string
    }
    let outageEnd = ''
    if (details.planned_on) {
      outageEnd = getLocalDateTimeString(
        parseDateTime(details.planned_on)
      ) as string
    } else if (details.estimated_on) {
      outageEnd = getLocalDateTimeString(
        parseDateTime(details.estimated_on)
      ) as string
    }

    if (details.extension === 'True') {
      outageEnd = getLocalDateTimeString(
        parseDateTime(details.estimated_on)
      ) as string
    }

    return `<div class="wc-outages__message">
        <h5>Water outage</h5>
        <h6>Work in progress to restore outage at ${affectedSuburbs}</h6>
        <p>An outage is currently being worked on in ${affectedSuburbs}.</p>
        <p>
            <strong>Outage start:</strong> ${outageStart}<br />
            <strong>Estimated water on:</strong> ${outageEnd}
        </p>
        <p>Updates will be provided as they become available</p>
        <p>Last updated: ${lastUpdated}</p>
        <p>
          We apologise for any inconvenience caused and appreciate your
          patience
        </p>
        <a href="${outagesFormUrl}" class="wc-link-arrow">Sign up for supply alerts</a>
      </div>`
  }
  if (details.status === 'Registered') {
    let plannedOff = ''
    if (details.planned_off) {
      plannedOff = getLocalDateTimeString(
        parseDateTime(details.planned_off)
      ) as string
    } else if (details.estimated_off) {
      plannedOff = getLocalDateTimeString(
        parseDateTime(details.estimated_off)
      ) as string
    }
    let plannedOn = ''
    if (details.planned_on) {
      plannedOn = getLocalDateTimeString(
        parseDateTime(details.planned_on)
      ) as string
    } else if (details.estimated_on) {
      plannedOn = getLocalDateTimeString(
        parseDateTime(details.estimated_on)
      ) as string
    }

    if (details.extension === 'True') {
      plannedOn = getLocalDateTimeString(
        parseDateTime(details.estimated_on)
      ) as string
    }

    let isPlanned = details.planned_flag === "True";
    const customerAffected = `<p><b>Affected customers:</b> ${details.affected_customers_outage}</p>`

    return `<div class="wc-outages__message">
        <h5>Upcoming water outage</h5>
          <h6>${isPlanned ? 'Scheduled maintenance is planned to begin in ' : 'Urgent repairs are required in '}${affectedSuburbs}</h6>
          <hr />
          <p>
              <b>${isPlanned ? 'Planned' : 'Estimated'} water off:</b> ${plannedOff}<br />
              <b>${isPlanned ? 'Planned' : 'Estimated'} water on:</b> ${plannedOn}
          </p>
        ${details.affected_customers_outage ? customerAffected : ''}
        <p>Updates will be provided as they become available</p>
        <p>
          We apologise for the inconvenience inconvenience and thank you for your patience while we complete this essential work.
        </p>
        <a href="${outagesFormUrl}" class="wc-link-arrow">Sign up for supply alerts</a>
      </div>`
  }

  if (details.status === 'Major') {
    let outageStart = ''
    if (details.actual_off) {
      outageStart = getLocalDateTimeString(
        parseDateTime(details.actual_off)
      ) as string
    } else if (details.estimated_off) {
      outageStart = getLocalDateTimeString(
        parseDateTime(details.estimated_off)
      ) as string
    }
    let outageEnd = ''
    if (details.planned_on) {
      outageEnd = getLocalDateTimeString(
        parseDateTime(details.planned_on)
      ) as string
    } else if (details.estimated_on) {
      outageEnd = getLocalDateTimeString(
        parseDateTime(details.estimated_on)
      ) as string
    }

    if (details.extension == 'True') {
      outageEnd = getLocalDateTimeString(
        parseDateTime(details.estimated_on)
      ) as string
    }
    return `<div class="wc-outages__message">
        <h5>${details.name || 'Major Works'}</h5>
        <h6>Works are underway at ${affectedSuburbs}</h6>
        <p>
            <strong>Start:</strong> ${outageStart}<br />
            <strong>End:</strong> ${outageEnd}
        </p>
        <p>
          ${details.notes}
        </p>
        <a href="${details?.url ?? outagesFormUrl}" class="wc-link-arrow">${details?.url ? "More about discoloured water" : "Sign up for supply alerts"}</a>
      </div>`
  }
  return `<div class="wc-outages__message">
        <h5>${affectedSuburbs}</h5>
        <h6>There are no known outages at this address</h6>
        <p>Last updated: ${lastUpdated}</p>
        <p>
          If you are experiencing a water outage at this address, please report the outage to one of our 24 hour support crew, so we can investigate.
        </p>
      </div>`
}
